<template>
    <div>
        <b-card class="bg-default-card no-padding" v-if="project">
            <b-tabs v-model="trajectoryProjectShowTabState" card>
                <b-tab :title="uLang('app.entity_details', { entity: lang('app.trajectory_project') })" active>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="inner">
                                <div class="mb-3">
                                    <router-link class="btn btn-brand" :to="{ name: 'admin.trajectory_projects.edit', params: { id: this.id } }">{{ uLang('app.edit_type', { type: lang('app.trajectory_project') }) }}</router-link>
                                    <a class="btn btn-brand" href="#" @click.prevent="duplicate">{{ uLang('app.duplicate_type', { type: lang('app.trajectory_project') }) }}</a>
                                </div>

                                <table class="table">
                                    <tr>
                                        <td width="200">{{ uLang('app.project_name') }}:</td>
                                        <td>{{ project.name }}</td>
                                    </tr>
                                    <tr v-if="project.purchase_cost_center">
                                        <td width="200">{{ uLang('app.selling_cost_center') }}:</td>
                                        <td>{{ project.selling_cost_center.value }}</td>
                                    </tr>
                                    <tr v-if="project.purchase_cost_center">
                                        <td width="200">{{ uLang('app.purchase_cost_center') }}:</td>
                                        <td>{{ project.purchase_cost_center.value }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.project_managers') }}:</td>
                                        <td>
                                            <b-badge v-for="project_manager of project.project_managers" :key="project_manager.id" pill variant="primary">
                                                <router-link :to="{ name: 'admin.relations.view', params: { id: project_manager.id }}">
                                                    {{ project_manager.full_name }}
                                                </router-link>
                                            </b-badge>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.contract') }}:</td>
                                        <td>
                                            <a :href="route('trajectory-projects.contract.download', {'trajectory_project': this.id})">
                                                {{ project.contract ? project.contract.name + '.' + project.contract.extension : null }}
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.start_date') }}:</td>
                                        <td>{{ project.start_date | date }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.end_date') }}:</td>
                                        <td>{{ project.end_date | date }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.client') }}:</td>
                                        <td>
                                            <b-badge v-if="project.client" pill variant="primary">
                                                <router-link :to="{ name: 'admin.organisations.view', params: { id: project.client.id }}">
                                                    {{ project.client.name }}
                                                </router-link>
                                            </b-badge>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.contact') }}:</td>
                                        <td>
                                            <b-badge v-if="project.contact" pill variant="primary">
                                                <router-link :to="{ name: 'admin.relations.view', params: { id: project.contact.id }}">
                                                    {{ project.contact.full_name }}
                                                </router-link>
                                            </b-badge>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.department') }}:</td>
                                        <td>{{ departmentName }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.results_appointments') }}:</td>
                                        <td>{{ project.results_appointments }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.expected_trajectories') }}:</td>
                                        <td>{{ project.expected_trajectories }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.maximum_trajectories') }}:</td>
                                        <td>{{ project.maximum_trajectories }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.lead_fee') }}:</td>
                                        <td>{{ project.lead_fee ? project.lead_fee + '%' : null }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.acquisition_fee') }}:</td>
                                        <td>{{ project.acquisition_fee ? project.acquisition_fee + '%' : null }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.client_project_number') }}:</td>
                                        <td>{{ project.client_project_number }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.accumulated_invoice') }}:</td>
                                        <td><b-badge pill variant="primary">{{ uLang('app.' + (project.accumulated_invoice ? 'yes' : 'no')) }}</b-badge></td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.active') }}:</td>
                                        <td><b-badge pill variant="primary">{{ uLang('app.' + (project.active ? 'yes' : 'no')) }}</b-badge></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab :title="uLang('app.trajectories')">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="pull-right mb-3">
                                <router-link class="btn btn-brand" :to="{ name: 'admin.trajectory_projects.trajectories.create', params: { projectId: this.id } }">{{ uLang('app.add_type', { type: lang('app.trajectory') }) }}</router-link>
                            </div>

                            <table-admin-trajectory :url="route('trajectory-projects.trajectories.table', { trajectory_project: this.id })"/>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
    import TableAdminTrajectory from '~/components/tables/admin/projects/trajectory/table'
    import FormAdminTrajectory from '~/components/forms/admin/projects/trajectory/form'

    export default {
        name: 'show',
        props: {
            id: {
                required: true,
            },
        },

        components: {
            'form-admin-trajectory': FormAdminTrajectory,
            'table-admin-trajectory': TableAdminTrajectory,
        },

        data() {
            return {
                project: undefined,
            }
        },

        computed: {
            overrideEndpoint() {
                return route('trajectory-projects.trajectories.store', { trajectory_project: this.id })
            },
            trajectoryProjectShowTabState: {
                get () { return this.$store.getters.tabState('trajectory-project-show') },
                set (v) { this.$store.commit('SET_TAB_STATE', { name: 'trajectory-project-show', value: v }) }
            },
            departmentName() {
                if (typeof window.getDepartmentById === "undefined" || this.project.department === null || this.project.department === "") {
                    return "";
                }

                return window.getDepartmentById(this.project.department).display_name;
            },
        },

        created() {
            this.retrieveProject();
        },

        methods: {
            async retrieveProject() {
                const {data} = await window.axios.get(route('trajectory-projects.show', { trajectory_project: this.id }));
                this.project = data;
            },

            edit() {
                this.$router.push({ name: 'admin.trajectory_projects.edit', params: { id: this.id } });
            },

            async duplicate() {
                let {data} = await window.axios.post(route('trajectory-projects.duplicate', { trajectory_project: this.id }));

                this.$router.push({ name: 'admin.trajectory_projects.edit', params: { id: data.id }});
            },
        },
    }
</script>

<style lang="scss" scoped>
    .card-block {
        padding: 0 !important;
    }
</style>
